function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.94 23.82a.99.99 0 01-.17-.02l-9.99-2C.78 21.6 0 20.64 0 19.62V1.82C0 1.26.24.74.65.4c.43-.34 1-.47 1.53-.36l9.59 1.92a1 1 0 01.46 0l9.6-1.92c.54-.11 1.1.02 1.51.36.42.34.66.86.66 1.42v17.8c0 1.02-.78 1.98-1.78 2.18l-9.99 2c-.1.02-.2.03-.29.02l-.17-.02h.03l.14.02zM11 21.6V3.84l-9-1.8v17.58c0 .08.1.2.18.22L11 21.6zm2-17.76V21.6l8.82-1.76c.08-.02.18-.14.18-.22V2.04l-9 1.8z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 7.82a1 1 0 01-.2-.02l-5-1a1 1 0 01.4-1.96l5 1a1 1 0 01.78 1.18c-.09.44-.46.76-.98.8zm0 5a1 1 0 01-.2-.02l-5-1a1 1 0 01.4-1.96l5 1a1 1 0 01.78 1.18c-.09.44-.46.76-.98.8zm0 5a1 1 0 01-.2-.02l-5-1a1 1 0 01.4-1.96l5 1a1 1 0 01.78 1.18c-.09.44-.46.76-.98.8zm6 0a1 1 0 01-.2-1.98l5-1a1 1 0 011.2.98 1 1 0 01-.8.98l-5 1-.2.02zm0-5a1 1 0 01-.2-1.98l5-1a1 1 0 011.2.98 1 1 0 01-.8.98l-5 1-.2.02zm0-5a1 1 0 01-.2-1.98l5-1a1 1 0 011.2.98 1 1 0 01-.8.98l-5 1-.2.02z"
});

var SvgIconRegisters = function SvgIconRegisters(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41
  }, props), _ref, _ref2);
};

export default SvgIconRegisters;